import { render } from "./VipTag.vue?vue&type=template&id=4ebdb4fa&scoped=true&ts=true&lang=pug"
import script from "./VipTag.vue?vue&type=script&lang=ts&setup=true"
export * from "./VipTag.vue?vue&type=script&lang=ts&setup=true"

import "./VipTag.vue?vue&type=style&index=0&id=4ebdb4fa&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebdb4fa"]])

export default __exports__